// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".design-facility[data-v-6b398806] {\n  font-family: var(--font-family);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* text-align: center; */\n  color: #2c3e50;\n}\n.scrolls[data-v-6b398806] {\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n.bound[data-v-6b398806] {\n  position: relative;\n}\n.svg-container[data-v-6b398806] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
